
$(function(){

  
  $('.pagetop').click(function () {
    $('[data-lp]').animate({
      scrollTop: 0
    }, 400);
    return false;
  });

  $('.menu').on('click',function(){
    $(this).toggleClass('js-active');
		if ( $(this).hasClass('js-active') ) {
      $('.menu_body').show();
      setTimeout(function(){
        $('.menu_body').addClass('js-active');
      },10); 
		} else {
      $('.menu_body').removeClass('js-active');
			setTimeout(function(){
        $('.menu_body').hide();
      },500); 
		}
  });
	$('.menu_body ul li a').click(function(){
		$('.menu').click();
  });

$('a[href^="#"]').click(function () {
  var adjust = 0;
  var speed = 300;
  var href = $(this).attr("href");
  var target = $(href === "#" || href === "" ? '[data-lp]' : href);
  if (!target.length) return false; // 対象がなければ何もしない

  var position = target.offset().top + adjust;
  $('html, body').animate({ scrollTop: position }, speed, 'swing');
  return false;
});


  $('.color-hover span').hover(
    function() {
      var index = $('.color-hover span').index(this);
      var index2 = $('.color-show').eq(index);
      index2.css('display', 'flex');
      gsap.fromTo(index2, {opacity: 0}, {opacity: 1, duration: 0.2});
    },
    function() {
      $('.color-show').hide();
    }
  );

  $('.products-slider').slick({
    infinite: true,
    speed: 500,
    fade: true,
    arrows: false,
    cssEase: 'linear'
  });
  $('.custom-slider').slick({
    infinite: false,
    speed: 300,
    infinite: true,
    arrows: true,
    cssEase: 'linear'
  });

  $('.products-thumb ul li').on('click', function () {
    var index = $('.products-thumb ul li').index(this);
    $('.products-thumb ul li').removeClass('js-active');
    $(this).addClass('js-active');
    $('.products-slider').slick('slickGoTo', index);
  });

  $('.color-hover span').click(function () {
    var index = $('.color-hover span').index(this);
    $('.products-slider').slick('slickGoTo', index);
    $('.products-thumb ul li').removeClass('js-active');
    $('.products-thumb ul li').eq(index).addClass('js-active');
  
    var position = $('#products').offset().top;
    $('html, body').animate({ scrollTop: position }, 300, 'swing');

  });
  

  $('.color-list__detail').click(function () {
    var index = $('.color-list__detail').index(this);
    $('.products-slider').slick('slickGoTo', index);
    $('.products-thumb ul li').removeClass('js-active');
    $('.products-thumb ul li').eq(index).addClass('js-active');
  
    var position = $('#products').offset().top;
    $('html, body').animate({ scrollTop: position }, 300, 'swing');  
    // return false;
  });
  

  document.querySelectorAll(".js-trigger").forEach((el, index) => {
    ScrollTrigger.create({
        trigger: el,
        id: index+1,
        start: 'top 50%',
        toggleClass: {targets: el, className: "is-inview"},
        once: true,
        // markers: true,
    });
  });

  ScrollTrigger.create({
    trigger: '.mv',
    start: 'top 80%',
    toggleClass: { targets: '.mv', className: 'is-inview' },
    once: true,
    // markers: true,
  });

  ScrollTrigger.create({
    trigger: '.movie-clip',
    start: '0 0',
    end: '300% 100%',
    pin: '.movie-clip__video',
    // markers: true,
  });

  
  ScrollTrigger.create({
    trigger: '.about', 
    start: '-50% 0%',
    end: 'bottom center',
    once: true,
    toggleClass: {targets: ".about .js-chara", className: "is-inview"},
    // markers: true,
  });

  ScrollTrigger.create({
    trigger: '.detail-wrap-pc',
    start: '0 0',
    end: '100% 100%',
    pin: '.detail-wrap-pc .detail-image',
    // markers: true,
  });
  ScrollTrigger.create({
    trigger: '.detail-wrap-pc',
    start: '0 0',
    end: '100% 100%',
    pin: '.detail-wrap-pc .detail-navi',
    // markers: true,
  });
  ScrollTrigger.create({
    trigger: '.detail-wrap-pc',
    start: '0 0',
    end: '100% 100%',
    pin: '.detail-wrap-pc .detail-number',
    //markers: true,
  });

  ScrollTrigger.create({
    trigger: '.detail-wrap-pc',
    start: '-16% 0%',
    end: '100% 0%',
    toggleClass: {targets: '.detail-wrap-pc .detail-image', className: 'is-inview-01'},
    // markers: true,
  });
  ScrollTrigger.create({
    trigger: '.detail-wrap-pc',
    start: '-8% 0',
    end: '100% 0%',
    toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi', className: 'is-hide-01'},
    // markers: true,
  });
  ScrollTrigger.create({
    trigger: '.detail-wrap-pc',
    start: '22% 0',
    end: '100% 0%',
    toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi_outer', className: 'is-inview-02'},
    // markers: true,
  });
  ScrollTrigger.create({
    trigger: '.detail-wrap-pc',
    start: '42% 0',
    end: '70% 0%',
    toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi', className: 'is-hide-02'},
    // markers: true,
  });
  // ScrollTrigger.create({
  //   trigger: '.detail-wrap-pc',
  //   start: '30% 0',
  //   end: '100% 0%',
  //   toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi_outer', className: 'is-inview-03'},
  // });
  // ScrollTrigger.create({
  //   trigger: '.detail-wrap-pc',
  //   start: '38% 0',
  //   end: '100% 0%',
  //   toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi', className: 'is-hide-03'},
  // });
  // ScrollTrigger.create({
  //   trigger: '.detail-wrap-pc',
  //   start: '50% 0',
  //   end: '100% 0%',
  //   toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi_outer', className: 'is-inview-04'},
  // });
  // ScrollTrigger.create({
  //   trigger: '.detail-wrap-pc',
  //   start: '58% 0',
  //   end: '100% 0%',
  //   toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi', className: 'is-hide-04'},
  // });
  // ScrollTrigger.create({
  //   trigger: '.detail-wrap-pc',
  //   start: '70% 0',
  //   end: '100% 0%',
  //   toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi_outer', className: 'is-inview-05'},
  // });
  // ScrollTrigger.create({
  //   trigger: '.detail-wrap-pc',
  //   start: '78% 0',
  //   end: '100% 0%',
  //   toggleClass: {targets: '.detail-wrap-pc .detail-image,.detail-wrap-pc .detail-navi', className: 'is-hide-05'},
  // });

  $(window).on('load', function() {
    ScrollTrigger.refresh();
  });
  

});